var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNonIotIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4267 24.8534L24.22 22.6467L22.9 21.3267L14.1333 12.56L11.5867 10.0134L7.76667 6.19336L6.82667 7.13336L9.91333 10.22C8.03333 10.8267 6.67333 12.5867 6.67333 14.66C6.67333 14.74 6.67333 14.8134 6.67333 14.8934C5.09333 15.4467 4 16.9467 4 18.66C4 20.8667 5.79333 22.66 8 22.66H22.3533L25.4933 25.8L26.4333 24.86L26.4267 24.8534ZM7.99333 21.3267C6.52 21.3267 5.32667 20.1334 5.32667 18.66C5.32667 17.3734 6.24667 16.2734 7.51333 16.04L8.17333 15.92L8.05333 15.26C8.01333 15.0467 7.99333 14.8467 7.99333 14.6534C7.99333 12.9134 9.34 11.5 11.04 11.3467L21.0133 21.32H7.99333V21.3267ZM14.7467 11.2867L13.78 10.32C15 8.47336 17.0733 7.32003 19.3267 7.32003C23 7.32003 25.9933 10.3134 25.9933 13.9867C25.9933 14.3667 25.96 14.7534 25.8867 15.1467C27.1667 15.8334 27.9933 17.18 27.9933 18.6534C27.9933 20.24 27.06 21.6134 25.72 22.2534L24.68 21.2134C25.8133 20.9067 26.66 19.88 26.66 18.6467C26.66 17.5334 25.9533 16.5334 24.8933 16.1467L24.32 15.94L24.48 15.3467C24.6 14.8867 24.6667 14.42 24.6667 13.9734C24.6667 11.0334 22.2733 8.64003 19.3333 8.64003C17.44 8.64003 15.7067 9.66003 14.7533 11.2667L14.7467 11.2867Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNonIotIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NonIot_Icon.e7824ec3da9c9a53306a7b07ba2bd051.svg";